import { computed, onScopeDispose } from 'vue'

import type { SearchContext } from '@common/shared-ui-layer/types/search-context'

import type { RouteLocationNormalizedLoaded } from 'vue-router'
import type { Router } from 'vue-router'

const DEBOUNCE_MS = 300

export function useCommunitiesSearchContext(route: RouteLocationNormalizedLoaded, router: Router): SearchContext {
  const shouldShowSearch = computed(() => route.name?.toString().startsWith('communities-groups-') ?? false)

  const initialQuery = computed(() => (route.query.query as string) || '')

  const updateQuery = (value: string) => {
    const trimmed = value?.trim()
    router.replace({
      path: route.path,
      query: { ...route.query, query: trimmed || undefined },
    })
  }

  let debounceTimer: ReturnType<typeof setTimeout> | null = null
  const onInputChange = (value: string) => {
    if (debounceTimer) clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      updateQuery(value)
      debounceTimer = null
    }, DEBOUNCE_MS)
  }

  const onSubmit = (query: string) => {
    updateQuery(query)
  }

  const onSearchClose = () => {
    const { query: _q, ...restQuery } = route.query
    router.replace({ path: route.path, query: restQuery })
  }

  onScopeDispose(() => {
    if (debounceTimer) {
      clearTimeout(debounceTimer)
      debounceTimer = null
    }
  })

  return {
    shouldShowSearch,
    initialQuery,
    onSubmit,
    onInputChange,
    onSearchClose,
  }
}
